import React from 'react'
import { driver, names } from '../../database/localStorage'
import { CountryCode } from '../../i18n/countryCodes'

export default function<T>(C: React.ComponentType<T>) {
  interface IWithLanguage {
    switchLanguage(lang: CountryCode): () => void
  }

  return class WithLoadLanguage extends React.Component<T & IWithLanguage> {
    public componentWillMount(): void {
      const lang = driver.getItem(
        names.UserAccountStorage.SelectedLanguage,
        'en',
      )
      this.props.switchLanguage(
        lang === 'en-US' ? 'en' : (lang as CountryCode),
      )()
    }

    public render(): React.ReactNode {
      return <C {...this.props} />
    }
  }
}
